export class BetTable {
  public static content: any = {
    "WPBet_QQPBet": {
      "WPBet": {
        "1": {
          "display": "WPStrategy_Win",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "360",
              "W_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "360",
              "W": "180",
              "W_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "120",
              "W_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "360",
              "W": "90",
              "W_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "350",
              "W": "70",
              "W_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "360",
              "W": "60",
              "W_bets": 6
            }
          }
        },
        "2": {
          "display": "WPStrategy_Place",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "P": "360",
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "360",
              "P": "180",
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "P": "120",
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "360",
              "P": "90",
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "350",
              "P": "70",
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "360",
              "P": "60",
              "P_bets": 6
            }
          }
        },
        "3": {
          "display": "WPStrategy_WinPlace",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "180",
              "P": "180",
              "W_bets": 1,
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "360",
              "W": "90",
              "P": "90",
              "W_bets": 2,
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "60",
              "P": "60",
              "W_bets": 3,
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "400",
              "W": "50",
              "P": "50",
              "W_bets": 4,
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "400",
              "W": "40",
              "P": "40",
              "W_bets": 5,
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "360",
              "W": "30",
              "P": "30",
              "W_bets": 6,
              "P_bets": 6
            }
          }
        },
        "4": {
          "display": "WPStrategy_Win1Place2",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "120",
              "P": "240",
              "W_bets": 1,
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "360",
              "W": "60",
              "P": "120",
              "W_bets": 2,
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "40",
              "P": "80",
              "W_bets": 3,
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "360",
              "W": "30",
              "P": "60",
              "W_bets": 4,
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "300",
              "W": "20",
              "P": "40",
              "W_bets": 5,
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "360",
              "W": "20",
              "P": "40",
              "W_bets": 6,
              "P_bets": 6
            }
          }
        },
        "5": {
          "display": "WPStrategy_Win1Place3",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "90",
              "P": "270",
              "W_bets": 1,
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "400",
              "W": "50",
              "P": "150",
              "W_bets": 2,
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "30",
              "P": "90",
              "W_bets": 3,
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "320",
              "W": "20",
              "P": "60",
              "W_bets": 4,
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "400",
              "W": "20",
              "P": "60",
              "W_bets": 5,
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "240",
              "W": "10",
              "P": "30",
              "W_bets": 6,
              "P_bets": 5
            }
          }
        },
        "6": {
          "display": "WPStrategy_Win1Place5",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "60",
              "P": "300",
              "W_bets": 1,
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "360",
              "W": "30",
              "P": "150",
              "W_bets": 2,
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "20",
              "P": "100",
              "W_bets": 3,
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "480",
              "W": "20",
              "P": "100",
              "W_bets": 4,
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "300",
              "W": "10",
              "P": "50",
              "W_bets": 5,
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "360",
              "W": "10",
              "P": "50",
              "W_bets": 6,
              "P_bets": 6
            }
          }
        },
        "7": {
          "display": "WPStrategy_Win2Place1",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "240",
              "P": "120",
              "W_bets": 1,
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "360",
              "W": "120",
              "P": "60",
              "W_bets": 2,
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "80",
              "P": "40",
              "W_bets": 3,
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "360",
              "W": "60",
              "P": "30",
              "W_bets": 4,
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "300",
              "W": "40",
              "P": "20",
              "W_bets": 5,
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "360",
              "W": "40",
              "P": "20",
              "W_bets": 6,
              "P_bets": 6
            }
          }
        },
        "8": {
          "display": "WPStrategy_Win3Place1",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "270",
              "P": "90",
              "W_bets": 1,
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "400",
              "W": "150",
              "P": "50",
              "W_bets": 2,
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "90",
              "P": "30",
              "W_bets": 3,
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "320",
              "W": "60",
              "P": "20",
              "W_bets": 4,
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "400",
              "W": "60",
              "P": "20",
              "W_bets": 5,
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "240",
              "W": "30",
              "P": "10",
              "W_bets": 6,
              "P_bets": 6
            }
          }
        },
        "9": {
          "display": "WPStrategy_Win5Place1",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "360",
              "W": "300",
              "P": "60",
              "W_bets": 1,
              "P_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "360",
              "W": "150",
              "P": "50",
              "W_bets": 2,
              "P_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "360",
              "W": "100",
              "P": "20",
              "W_bets": 3,
              "P_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "480",
              "W": "100",
              "P": "20",
              "W_bets": 4,
              "P_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "300",
              "W": "50",
              "P": "10",
              "W_bets": 5,
              "P_bets": 5
            },
            "6": {
              "total_bets": 6,
              "value": "360",
              "W": "50",
              "P": "10",
              "W_bets": 6,
              "P_bets": 6
            }
          }
        }
      },
      "QQPBet": {
        "horse_selected_banker_sel": {
          "1": {
            "display": "QQPStrategy_Q",
            "bet_value": {
              "1": {
                "total_bets": 1,
                "value": "360",
                "Q": "360",
                "Q_bets": 1
              },
              "2": {
                "total_bets": 2,
                "value": "360",
                "Q": "180",
                "Q_bets": 2
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "120",
                "Q_bets": 3
              },
              "4": {
                "total_bets": 4,
                "value": "360",
                "Q": "90",
                "Q_bets": 4
              },
              "5": {
                "total_bets": 5,
                "value": "350",
                "Q": "70",
                "Q_bets": 5
              }
            }
          },
          "2": {
            "display": "QQPStrategy_QP",
            "bet_value": {
              "1": {
                "total_bets": 1,
                "value": "360",
                "QP": "360",
                "QP_bets": 1
              },
              "2": {
                "total_bets": 2,
                "value": "360",
                "QP": "180",
                "QP_bets": 2
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "QP": "120",
                "QP_bets": 3
              },
              "4": {
                "total_bets": 4,
                "value": "360",
                "QP": "90",
                "QP_bets": 4
              },
              "5": {
                "total_bets": 5,
                "value": "350",
                "QP": "70",
                "QP_bets": 5
              }
            }
          },
          "3": {
            "display": "QQPStrategy_QQP",
            "bet_value": {
              "1": {
                "total_bets": 1,
                "value": "360",
                "Q": "180",
                "QP": "180",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "2": {
                "total_bets": 2,
                "value": "360",
                "Q": "90",
                "QP": "90",
                "Q_bets": 2,
                "QP_bets": 2
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "60",
                "QP": "60",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 4,
                "value": "400",
                "Q": "50",
                "QP": "50",
                "Q_bets": 4,
                "QP_bets": 4
              },
              "5": {
                "total_bets": 5,
                "value": "400",
                "Q": "40",
                "QP": "40",
                "Q_bets": 5,
                "QP_bets": 5
              }
            }
          },
          "4": {
            "display": "QQPStrategy_Q1QP2",
            "bet_value": {
              "1": {
                "total_bets": 1,
                "value": "360",
                "Q": "120",
                "QP": "240",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "2": {
                "total_bets": 2,
                "value": "360",
                "Q": "60",
                "QP": "120",
                "Q_bets": 2,
                "QP_bets": 2
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "40",
                "QP": "80",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 4,
                "value": "360",
                "Q": "30",
                "QP": "60",
                "Q_bets": 4,
                "QP_bets": 4
              },
              "5": {
                "total_bets": 5,
                "value": "300",
                "Q": "20",
                "QP": "40",
                "Q_bets": 5,
                "QP_bets": 5
              }
            }
          },
          "5": {
            "display": "QQPStrategy_Q1QP3",
            "bet_value": {
              "1": {
                "total_bets": 1,
                "value": "360",
                "Q": "90",
                "QP": "270",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "2": {
                "total_bets": 2,
                "value": "400",
                "Q": "50",
                "QP": "150",
                "Q_bets": 2,
                "QP_bets": 2
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "30",
                "QP": "90",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 4,
                "value": "320",
                "Q": "20",
                "QP": "60",
                "Q_bets": 4,
                "QP_bets": 4
              },
              "5": {
                "total_bets": 5,
                "value": "400",
                "Q": "20",
                "QP": "60",
                "Q_bets": 5,
                "QP_bets": 5
              }
            }
          },
          "6": {
            "display": "QQPStrategy_Q1QP5",
            "bet_value": {}
          },
          "7": {
            "display": "QQPStrategy_Q2QP1",
            "bet_value": {
              "1": {
                "total_bets": 1,
                "value": "360",
                "Q": "240",
                "QP": "120",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "2": {
                "total_bets": 2,
                "value": "360",
                "Q": "120",
                "QP": "60",
                "Q_bets": 2,
                "QP_bets": 2
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "80",
                "QP": "40",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 4,
                "value": "360",
                "Q": "60",
                "QP": "30",
                "Q_bets": 4,
                "QP_bets": 4
              },
              "5": {
                "total_bets": 5,
                "value": "300",
                "Q": "40",
                "QP": "20",
                "Q_bets": 5,
                "QP_bets": 5
              }
            }
          },
          "8": {
            "display": "QQPStrategy_Q3QP1",
            "bet_value": {
              "1": {
                "total_bets": 1,
                "value": "360",
                "Q": "270",
                "QP": "90",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "2": {
                "total_bets": 2,
                "value": "400",
                "Q": "150",
                "QP": "50",
                "Q_bets": 2,
                "QP_bets": 2
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "90",
                "QP": "30",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 4,
                "value": "320",
                "Q": "60",
                "QP": "20",
                "Q_bets": 4,
                "QP_bets": 4
              },
              "5": {
                "total_bets": 5,
                "value": "400",
                "Q": "60",
                "QP": "20",
                "Q_bets": 5,
                "QP_bets": 5
              }
            }
          },
          "9": {
            "display": "QQPStrategy_Q5QP1",
            "bet_value": {}
          }
        },
        "horse_selected_cross_sel": {
          "1": {
            "display": "QQPStrategy_Q",
            "bet_value": {
              "2": {
                "total_bets": 1,
                "value": "360",
                "Q": "360",
                "Q_bets": 1
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "120",
                "Q_bets": 3
              },
              "4": {
                "total_bets": 6,
                "value": "360",
                "Q": "60",
                "Q_bets": 6
              },
              "5": {
                "total_bets": 10,
                "value": "400",
                "Q": "40",
                "Q_bets": 10
              },
              "6": {
                "total_bets": 15,
                "value": "300",
                "Q": "20",
                "Q_bets": 15
              }
            }
          },
          "2": {
            "display": "QQPStrategy_QP",
            "bet_value": {
              "2": {
                "total_bets": 1,
                "value": "360",
                "QP": "360",
                "QP_bets": 1
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "QP": "120",
                "QP_bets": 3
              },
              "4": {
                "total_bets": 6,
                "value": "360",
                "QP": "60",
                "QP_bets": 6
              },
              "5": {
                "total_bets": 10,
                "value": "400",
                "QP": "40",
                "QP_bets": 10
              },
              "6": {
                "total_bets": 15,
                "value": "300",
                "QP": "20",
                "QP_bets": 15
              }
            }
          },
          "3": {
            "display": "QQPStrategy_QQP",
            "bet_value": {
              "2": {
                "total_bets": 1,
                "value": "360",
                "Q": "180",
                "QP": "180",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "60",
                "QP": "60",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 6,
                "value": "360",
                "Q": "30",
                "QP": "30",
                "Q_bets": 6,
                "QP_bets": 6
              },
              "5": {
                "total_bets": 10,
                "value": "400",
                "Q": "20",
                "QP": "20",
                "Q_bets": 10,
                "QP_bets": 10
              },
              "6": {
                "total_bets": 15,
                "value": "300",
                "Q": "10",
                "QP": "10",
                "Q_bets": 15,
                "QP_bets": 15
              }
            }
          },
          "4": {
            "display": "QQPStrategy_Q1QP2",
            "bet_value": {
              "2": {
                "total_bets": 1,
                "value": "360",
                "Q": "120",
                "QP": "240",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "40",
                "QP": "80",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 6,
                "value": "360",
                "Q": "20",
                "QP": "40",
                "Q_bets": 6,
                "QP_bets": 6
              },
              "5": {
                "total_bets": 10,
                "value": "300",
                "Q": "10",
                "QP": "20",
                "Q_bets": 10,
                "QP_bets": 10
              },
              "6": {
                "total_bets": 15,
                "value": "450",
                "Q": "10",
                "QP": "20",
                "Q_bets": 15,
                "QP_bets": 15
              }
            }
          },
          "5": {
            "display": "QQPStrategy_Q1QP3",
            "bet_value": {
              "2": {
                "total_bets": 1,
                "value": "360",
                "Q": "90",
                "QP": "270",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "30",
                "QP": "90",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 6,
                "value": "480",
                "Q": "20",
                "QP": "60",
                "Q_bets": 6,
                "QP_bets": 6
              },
              "5": {
                "total_bets": 10,
                "value": "400",
                "Q": "10",
                "QP": "30",
                "Q_bets": 10,
                "QP_bets": 10
              },
              "6": {
                "total_bets": 15,
                "value": "600",
                "Q": "10",
                "QP": "30",
                "Q_bets": 15,
                "QP_bets": 15
              }
            }
          },
          "6": {
            "display": "QQPStrategy_Q1QP5",
            "bet_value": {}
          },
          "7": {
            "display": "QQPStrategy_Q2QP1",
            "bet_value": {
              "2": {
                "total_bets": 1,
                "value": "360",
                "Q": "240",
                "QP": "120",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "80",
                "QP": "40",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 6,
                "value": "360",
                "Q": "40",
                "QP": "20",
                "Q_bets": 6,
                "QP_bets": 6
              },
              "5": {
                "total_bets": 10,
                "value": "300",
                "Q": "20",
                "QP": "10",
                "Q_bets": 10,
                "QP_bets": 10
              },
              "6": {
                "total_bets": 15,
                "value": "450",
                "Q": "20",
                "QP": "10",
                "Q_bets": 15,
                "QP_bets": 15
              }
            }
          },
          "8": {
            "display": "QQPStrategy_Q3QP1",
            "bet_value": {
              "2": {
                "total_bets": 1,
                "value": "360",
                "Q": "270",
                "QP": "90",
                "Q_bets": 1,
                "QP_bets": 1
              },
              "3": {
                "total_bets": 3,
                "value": "360",
                "Q": "90",
                "QP": "30",
                "Q_bets": 3,
                "QP_bets": 3
              },
              "4": {
                "total_bets": 6,
                "value": "480",
                "Q": "60",
                "QP": "20",
                "Q_bets": 6,
                "QP_bets": 6
              },
              "5": {
                "total_bets": 10,
                "value": "400",
                "Q": "30",
                "QP": "10",
                "Q_bets": 10,
                "QP_bets": 10
              },
              "6": {
                "total_bets": 15,
                "value": "600",
                "Q": "30",
                "QP": "10",
                "Q_bets": 15,
                "QP_bets": 15
              }
            }
          },
          "9": {
            "display": "QQPStrategy_Q5QP1",
            "bet_value": {}
          }
        }
      }
    },
    "WPBet": {
      "1": {
        "display": "WPStrategy_Win",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "720",
            "W_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "360",
            "W_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "240",
            "W_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "720",
            "W": "180",
            "W_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "700",
            "W": "140",
            "W_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "120",
            "W_bets": 6
          }
        }
      },
      "2": {
        "display": "WPStrategy_Place",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "P": "720",
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "P": "360",
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "P": "240",
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "720",
            "P": "180",
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "700",
            "P": "140",
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "P": "120",
            "P_bets": 6
          }
        }
      },
      "3": {
        "display": "WPStrategy_WinPlace",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "360",
            "P": "360",
            "W_bets": 1,
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "180",
            "P": "180",
            "W_bets": 2,
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "120",
            "P": "120",
            "W_bets": 3,
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "720",
            "W": "90",
            "P": "90",
            "W_bets": 4,
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "700",
            "W": "70",
            "P": "70",
            "W_bets": 5,
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "60",
            "P": "60",
            "W_bets": 6,
            "P_bets": 6
          }
        }
      },
      "4": {
        "display": "WPStrategy_Win1Place2",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "240",
            "P": "480",
            "W_bets": 1,
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "120",
            "P": "240",
            "W_bets": 2,
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "80",
            "P": "160",
            "W_bets": 3,
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "720",
            "W": "60",
            "P": "120",
            "W_bets": 4,
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "750",
            "W": "50",
            "P": "100",
            "W_bets": 5,
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "40",
            "P": "80",
            "W_bets": 6,
            "P_bets": 6
          }
        }
      },
      "5": {
        "display": "WPStrategy_Win1Place3",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "180",
            "P": "540",
            "W_bets": 1,
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "90",
            "P": "270",
            "W_bets": 2,
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "60",
            "P": "180",
            "W_bets": 3,
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "800",
            "W": "50",
            "P": "150",
            "W_bets": 4,
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "800",
            "W": "40",
            "P": "120",
            "W_bets": 5,
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "30",
            "P": "90",
            "W_bets": 6,
            "P_bets": 6
          }
        }
      },
      "6": {
        "display": "WPStrategy_Win1Place5",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "120",
            "P": "600",
            "W_bets": 1,
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "60",
            "P": "300",
            "W_bets": 2,
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "40",
            "P": "200",
            "W_bets": 3,
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "720",
            "W": "30",
            "P": "150",
            "W_bets": 4,
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "600",
            "W": "20",
            "P": "100",
            "W_bets": 5,
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "20",
            "P": "100",
            "W_bets": 6,
            "P_bets": 6
          }
        }
      },
      "7": {
        "display": "WPStrategy_Win2Place1",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "480",
            "P": "240",
            "W_bets": 1,
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "240",
            "P": "120",
            "W_bets": 2,
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "160",
            "P": "80",
            "W_bets": 3,
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "720",
            "W": "120",
            "P": "60",
            "W_bets": 4,
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "750",
            "W": "100",
            "P": "50",
            "W_bets": 5,
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "80",
            "P": "40",
            "W_bets": 6,
            "P_bets": 6
          }
        }
      },
      "8": {
        "display": "WPStrategy_Win3Place1",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "540",
            "P": "180",
            "W_bets": 1,
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "270",
            "P": "90",
            "W_bets": 2,
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "180",
            "P": "60",
            "W_bets": 3,
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "800",
            "W": "150",
            "P": "50",
            "W_bets": 4,
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "800",
            "W": "120",
            "P": "40",
            "W_bets": 5,
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "90",
            "P": "30",
            "W_bets": 6,
            "P_bets": 6
          }
        }
      },
      "9": {
        "display": "WPStrategy_Win5Place1",
        "bet_value": {
          "1": {
            "total_bets": 1,
            "value": "720",
            "W": "600",
            "P": "120",
            "W_bets": 1,
            "P_bets": 1
          },
          "2": {
            "total_bets": 2,
            "value": "720",
            "W": "300",
            "P": "60",
            "W_bets": 2,
            "P_bets": 2
          },
          "3": {
            "total_bets": 3,
            "value": "720",
            "W": "200",
            "P": "40",
            "W_bets": 3,
            "P_bets": 3
          },
          "4": {
            "total_bets": 4,
            "value": "720",
            "W": "150",
            "P": "30",
            "W_bets": 4,
            "P_bets": 4
          },
          "5": {
            "total_bets": 5,
            "value": "600",
            "W": "100",
            "P": "20",
            "W_bets": 5,
            "P_bets": 5
          },
          "6": {
            "total_bets": 6,
            "value": "720",
            "W": "100",
            "P": "20",
            "W_bets": 5,
            "P_bets": 6
          }
        }
      }
    },
    "QQPBet": {
      "horse_selected_banker_sel": {
        "1": {
          "display": "QQPStrategy_Q",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "720",
              "Q": "720",
              "Q_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "720",
              "Q": "360",
              "Q_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "240",
              "Q_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "720",
              "Q": "180",
              "Q_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "700",
              "Q": "140",
              "Q_bets": 5
            }
          }
        },
        "2": {
          "display": "QQPStrategy_QP",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "720",
              "QP": "720",
              "QP_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "720",
              "QP": "360",
              "QP_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "QP": "240",
              "QP_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "720",
              "QP": "180",
              "QP_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "700",
              "QP": "140",
              "QP_bets": 5
            }
          }
        },
        "3": {
          "display": "QQPStrategy_QQP",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "720",
              "Q": "360",
              "QP": "360",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "720",
              "Q": "180",
              "QP": "180",
              "Q_bets": 2,
              "QP_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "120",
              "QP": "120",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "720",
              "Q": "90",
              "QP": "90",
              "Q_bets": 4,
              "QP_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "700",
              "Q": "70",
              "QP": "70",
              "Q_bets": 5,
              "QP_bets": 5
            }
          }
        },
        "4": {
          "display": "QQPStrategy_Q1QP2",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "720",
              "Q": "240",
              "QP": "480",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "720",
              "Q": "120",
              "QP": "240",
              "Q_bets": 2,
              "QP_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "80",
              "QP": "160",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "720",
              "Q": "60",
              "QP": "120",
              "Q_bets": 4,
              "QP_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "750",
              "Q": "50",
              "QP": "100",
              "Q_bets": 5,
              "QP_bets": 5
            }
          }
        },
        "5": {
          "display": "QQPStrategy_Q1QP3",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "720",
              "Q": "180",
              "QP": "540",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "720",
              "Q": "90",
              "QP": "270",
              "Q_bets": 2,
              "QP_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "60",
              "QP": "180",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "800",
              "Q": "50",
              "QP": "150",
              "Q_bets": 4,
              "QP_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "800",
              "Q": "40",
              "QP": "120",
              "Q_bets": 5,
              "QP_bets": 5
            }
          }
        },
        "6": {
          "display": "QQPStrategy_Q1QP5",
          "bet_value": {}
        },
        "7": {
          "display": "QQPStrategy_Q2QP1",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "720",
              "Q": "480",
              "QP": "240",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "720",
              "Q": "240",
              "QP": "120",
              "Q_bets": 2,
              "QP_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "160",
              "QP": "80",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "720",
              "Q": "120",
              "QP": "60",
              "Q_bets": 4,
              "QP_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "750",
              "Q": "100",
              "QP": "50",
              "Q_bets": 5,
              "QP_bets": 5
            }
          }
        },
        "8": {
          "display": "QQPStrategy_Q3QP1",
          "bet_value": {
            "1": {
              "total_bets": 1,
              "value": "720",
              "Q": "540",
              "QP": "180",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "2": {
              "total_bets": 2,
              "value": "720",
              "Q": "270",
              "QP": "90",
              "Q_bets": 2,
              "QP_bets": 2
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "180",
              "QP": "60",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 4,
              "value": "800",
              "Q": "150",
              "QP": "50",
              "Q_bets": 4,
              "QP_bets": 4
            },
            "5": {
              "total_bets": 5,
              "value": "800",
              "Q": "120",
              "QP": "40",
              "Q_bets": 5,
              "QP_bets": 5
            }
          }
        },
        "9": {
          "display": "QQPStrategy_Q5QP1",
          "bet_value": {}
        }
      },
      "horse_selected_cross_sel": {
        "1": {
          "display": "QQPStrategy_Q",
          "bet_value": {
            "2": {
              "total_bets": 1,
              "value": "720",
              "Q": "720",
              "Q_bets": 1
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "240",
              "Q_bets": 3
            },
            "4": {
              "total_bets": 6,
              "value": "720",
              "Q": "120",
              "Q_bets": 6
            },
            "5": {
              "total_bets": 10,
              "value": "700",
              "Q": "70",
              "Q_bets": 10
            },
            "6": {
              "total_bets": 15,
              "value": "750",
              "Q": "50",
              "Q_bets": 15
            }
          }
        },
        "2": {
          "display": "QQPStrategy_QP",
          "bet_value": {
            "2": {
              "total_bets": 1,
              "value": "720",
              "QP": "720",
              "QP_bets": 1
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "QP": "240",
              "QP_bets": 3
            },
            "4": {
              "total_bets": 6,
              "value": "720",
              "QP": "120",
              "QP_bets": 6
            },
            "5": {
              "total_bets": 10,
              "value": "700",
              "QP": "70",
              "QP_bets": 10
            },
            "6": {
              "total_bets": 15,
              "value": "750",
              "QP": "50",
              "QP_bets": 15
            }
          }
        },
        "3": {
          "display": "QQPStrategy_QQP",
          "bet_value": {
            "2": {
              "total_bets": 1,
              "value": "720",
              "Q": "360",
              "QP": "360",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "120",
              "QP": "120",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 6,
              "value": "720",
              "Q": "60",
              "QP": "60",
              "Q_bets": 6,
              "QP_bets": 6
            },
            "5": {
              "total_bets": 10,
              "value": "800",
              "Q": "40",
              "QP": "40",
              "Q_bets": 10,
              "QP_bets": 10
            },
            "6": {
              "total_bets": 15,
              "value": "600",
              "Q": "20",
              "QP": "20",
              "Q_bets": 15,
              "QP_bets": 15
            }
          }
        },
        "4": {
          "display": "QQPStrategy_Q1QP2",
          "bet_value": {
            "2": {
              "total_bets": 1,
              "value": "720",
              "Q": "240",
              "QP": "480",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "80",
              "QP": "160",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 6,
              "value": "720",
              "Q": "40",
              "QP": "80",
              "Q_bets": 6,
              "QP_bets": 6
            },
            "5": {
              "total_bets": 10,
              "value": "900",
              "Q": "30",
              "QP": "60",
              "Q_bets": 10,
              "QP_bets": 10
            },
            "6": {
              "total_bets": 15,
              "value": "900",
              "Q": "20",
              "QP": "40",
              "Q_bets": 15,
              "QP_bets": 15
            }
          }
        },
        "5": {
          "display": "QQPStrategy_Q1QP3",
          "bet_value": {
            "2": {
              "total_bets": 1,
              "value": "720",
              "Q": "180",
              "QP": "540",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "60",
              "QP": "180",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 6,
              "value": "720",
              "Q": "30",
              "QP": "90",
              "Q_bets": 6,
              "QP_bets": 6
            },
            "5": {
              "total_bets": 10,
              "value": "800",
              "Q": "20",
              "QP": "60",
              "Q_bets": 10,
              "QP_bets": 10
            },
            "6": {
              "total_bets": 15,
              "value": "600",
              "Q": "10",
              "QP": "30",
              "Q_bets": 15,
              "QP_bets": 15
            }
          }
        },
        "6": {
          "display": "QQPStrategy_Q1QP5",
          "bet_value": {}
        },
        "7": {
          "display": "QQPStrategy_Q2QP1",
          "bet_value": {
            "2": {
              "total_bets": 1,
              "value": "720",
              "Q": "480",
              "QP": "240",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "160",
              "QP": "80",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 6,
              "value": "720",
              "Q": "80",
              "QP": "40",
              "Q_bets": 6,
              "QP_bets": 6
            },
            "5": {
              "total_bets": 10,
              "value": "900",
              "Q": "60",
              "QP": "30",
              "Q_bets": 10,
              "QP_bets": 10
            },
            "6": {
              "total_bets": 15,
              "value": "900",
              "Q": "40",
              "QP": "20",
              "Q_bets": 15,
              "QP_bets": 15
            }
          }
        },
        "8": {
          "display": "QQPStrategy_Q3QP1",
          "bet_value": {
            "2": {
              "total_bets": 1,
              "value": "720",
              "Q": "540",
              "QP": "180",
              "Q_bets": 1,
              "QP_bets": 1
            },
            "3": {
              "total_bets": 3,
              "value": "720",
              "Q": "180",
              "QP": "60",
              "Q_bets": 3,
              "QP_bets": 3
            },
            "4": {
              "total_bets": 6,
              "value": "720",
              "Q": "90",
              "QP": "30",
              "Q_bets": 6,
              "QP_bets": 6
            },
            "5": {
              "total_bets": 10,
              "value": "800",
              "Q": "60",
              "QP": "20",
              "Q_bets": 10,
              "QP_bets": 10
            },
            "6": {
              "total_bets": 15,
              "value": "600",
              "Q": "30",
              "QP": "10",
              "Q_bets": 15,
              "QP_bets": 15
            }
          }
        },
        "9": {
          "display": "QQPStrategy_Q5QP1",
          "bet_value": {}
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/horse/horse-bet-data/BetTable.ts